// What the Audit Logs page dispatches.
const actions = {
  SET_STATE: 'auditLogs/SET_STATE',
  LIST_AUDIT_LOGS: 'auditLogs/LIST_AUDIT_LOGS',
  FETCH_AUDIT_LOG_CATALOG: 'auditLogs/FETCH_AUDIT_LOG_CATALOG',
  FETCH_AUDIT_LOG_ACTORS: 'auditLogs/FETCH_AUDIT_LOG_ACTORS',
  FETCH_AUDIT_LOG: 'auditLogs/FETCH_AUDIT_LOG',
  EXPORT_AUDIT_LOGS: 'auditLogs/EXPORT_AUDIT_LOGS',
  RESET: 'auditLogs/RESET',
}

export default actions
